/**
 * Convert a currency symbol to a Google Material Icon key. Defaults to US dollar.
 * @param currencySymbol Currency symbol to render
 * @returns The MaterialIcon key (if none exists, returns the attach_money)
 */
export const currencyIcon = (currencySymbol: string): string => {
  switch (currencySymbol) {
    case '£': {
      return 'currency_pound';
    }

    case '€': {
      return 'euro_symbol';
    }

    case '¥': {
      return 'currency_yen';
    }

    default: {
      return 'attach_money';
    }
  }
};
